<template>
  <v-main class="primary">
  <loader-component v-if="loading"></loader-component>
  <v-container v-else fluid>
    <v-row v-if="loadingPersonalData" align="center" justify="center" style="min-height: 60vh">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
        <div class="text-h6 mt-4">Cargando información del personal...</div>
      </v-col>
    </v-row>

    <v-row v-else-if="!personal" align="center" justify="center" style="min-height: 60vh">
      <v-col cols="12" class="text-center">
        <v-icon color="error" size="80">mdi-account-alert</v-icon>
        <h2 class="mt-2">No se encontró información de personal</h2>
        <v-btn color="secondary" class="mt-4" rounded @click="recargarDatos">
          <v-icon left>mdi-refresh</v-icon>
          Reintentar
        </v-btn>
      </v-col>
    </v-row>

    <template v-else>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="auto" align="right">
          <NotificacionesPoliciaMenu
            :evaluaciones="evaluaciones"
            :convocatorias="convocatoriasNotificaciones"
            @navigate-to-evaluation="handleNavigateToEvaluation"
          />
          <v-menu offset-y left transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="secondary" v-bind="attrs" v-on="on" class="mx-2">
                <v-icon>mdi-account-cog</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="generatePdf">
                <v-list-item-title>Descargar currículum</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="personal.foto && personal.foto.length > 0" @click="download(personal.foto)">
                <v-list-item-title>Descargar fotografía</v-list-item-title>
              </v-list-item>
              <ResetPasswordDialogComponent />
              <v-divider></v-divider>
              <v-list-item @click="triggerLogout()">
                <v-list-item-title>Cerrar sesión</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>

      <FormatoCurriculumVitae ref="cv" :personal="personal" :estudios="estudios" />

      <v-row>
        <v-col cols="3">
          <v-row>
            <v-col cols="12">
              <personal-card-component :personal="personal"></personal-card-component>
            </v-col>
            <v-col cols="12">
              <menu-list-component :loading="false" :estatus="personal.fk_idEstatus"></menu-list-component>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <datos-generales-component
            v-if="selectedMenu == 1"
            :personal="personal"
            :estudios="estudiosPersonal"
          ></datos-generales-component>
          <referencias-component
            v-if="selectedMenu == 2"
            :personal="personal"
            :referencias="referencias"
            :familiares="familiares"
          ></referencias-component>
          <documentos-component
            v-if="selectedMenu == 3"
            :documentos="documentos"
            :id="personal.idPersonal"
          ></documentos-component>
          <desarrollo-elemento-component
            v-if="selectedMenu == 4"
            :idPersonal="personal.idPersonal"
            :estatus="personal.fk_idEstatus"
          ></desarrollo-elemento-component>
          <puesto-dependencia-component v-if="selectedMenu == 5" :personal="personal"></puesto-dependencia-component>
          <ResultadosC3Section v-if="selectedMenu == 6" :personal="personal"></ResultadosC3Section>
          <faltas-administrativas-component
            v-if="selectedMenu == 8"
            :faltas="faltasAdministrativas"
          ></faltas-administrativas-component>
          <linea-tiempo-component v-if="selectedMenu == 7" :permutaciones="permutaciones"></linea-tiempo-component>
          <media-filiacion-component
            v-if="selectedMenu == 9"
            :media-filiacion="personal.mediafiliacion"
            :personal="personal"
            :senias-particulares="personal.seniasParticulares"
          ></media-filiacion-component>
          <evaluaciones-component
            v-if="selectedMenu == 10"
            :personal="personal"
            :evaluaciones="evaluaciones"
          ></evaluaciones-component>
          <carrera-policial-component
            v-if="selectedMenu == 11"
            :personal="personal"
            :estatus="personal.fk_idEstatus"
            :condecoraciones="condecoraciones"
          ></carrera-policial-component>
        </v-col>
      </v-row>
    </template>
  </v-container>
  </v-main>
</template>
<style scoped>
.selectable {
  cursor: pointer;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import LoaderComponent from '../../components/LoaderComponent.vue'
import PersonalCardComponent from '../../components/expediente/PersonalCardComponent.vue'
import MenuListComponent from '../../components/expediente/MenuListComponent.vue'
import DatosGeneralesComponent from '../../components/expediente/DatosGeneralesComponent.vue'
import DocumentosComponent from '../../components/expediente/DocumentosComponent.vue'
import DesarrolloElementoComponent from '../../components/expediente/DesarrolloElemento.vue'
import ResultadosC3Section from '../../components/expediente/ResultadosC3Section.vue'
import ReferenciasComponent from '../../components/expediente/ReferenciasComponent.vue'
import PuestoDependenciaComponent from '../../components/expediente/PuestoDependenciaComponent'
import FaltasAdministrativasComponent from '../../components/expediente/FaltasAdministrativasComponent.vue'
import FamiliaresComponent from '../../components/expediente/FamiliaresComponent.vue'
import LineaTiempoComponent from '../../components/expediente/LineaTiempoComponent.vue'
import MediaFiliacionComponent from '../../components/expediente/MediaFiliacionComponent.vue'
import EvaluacionesComponent from '../../components/expediente/EvaluacionesComponent.vue'
import CarreraPolicialComponent from '../../components/expediente/CarreraPolicialComponent.vue'
import FormatoCurriculumVitae from '../../components/FormatoCurriculumVitae.vue'
import NotificacionesPoliciaMenu from '../../views/policia/notificaciones/NotificacionesPoliciaMenu.vue'
import { MODULOS } from '../../perfiles'
import redirectToModuleByPerfil from '../../utils/redirectToModuleByPerfil'
import TextButton from '../../components/base/TextButton.vue'
import ResetPasswordDialogComponent from '../../components/ResetPasswordDialogComponent.vue'

export default {
  components: {
    LoaderComponent,
    PersonalCardComponent,
    MenuListComponent,
    DatosGeneralesComponent,
    DocumentosComponent,
    DesarrolloElementoComponent,
    ResultadosC3Section,
    ReferenciasComponent,
    PuestoDependenciaComponent,
    FaltasAdministrativasComponent,
    FamiliaresComponent,
    LineaTiempoComponent,
    MediaFiliacionComponent,
    EvaluacionesComponent,
    CarreraPolicialComponent,
    FormatoCurriculumVitae,
    NotificacionesPoliciaMenu,
    TextButton,
    ResetPasswordDialogComponent,
  },

  async mounted() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.POLICIA)
    this.ensureIsAllowedUser()
    await this.SET_SELECTED_MENU(1)
    await this.cargarDatosIniciales()
    this.DISABLE_LOADER()
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      loadingPersonalData: false,

      estadoNace: null,
      municipioNace: null,
      estadoRadica: null,
      municipioRadica: null,
      estadoDireccion: null,
      municipioDireccion: null,
      saveChanges: false,
      menuNacimiento: false,
      date: null,
    }
  },

  watch: {
    menuNacimiento(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),

    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),

    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),

    ...mapGetters('documento', {
      documentos: 'getDocumentos',
    }),

    ...mapGetters('tipoNacionalidad', {
      tipoNacionalidad: 'getTipoNacionalidad',
    }),

    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),

    ...mapGetters('estado', {
      estados: 'getEstados',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
    }),

    ...mapGetters('biometrico', {
      biometricosPersonal: 'getBiometricosPersonal',
    }),

    ...mapGetters('asignacionEquipo', {
      equipamientoPersonal: 'getAsignacionesEquipo',
    }),

    ...mapGetters('cursoAsignado', {
      cursos: 'getCursosAsignadosPersonal',
    }),

    ...mapGetters('productividad', {
      evaluacionesProductividad: 'getProductividad',
    }),

    ...mapGetters('respetoPrincipios', {
      evaluacionesRespetoPrincipios: 'getRespetoPrincipios',
    }),

    ...mapGetters('expediente', {
      selectedMenu: 'getSelectedMenu',
    }),

    ...mapGetters('evaluacionMedica', {
      evaluacionesMedicas: 'getEvaluacionMedica',
    }),

    ...mapGetters('dictamenPersonal', {
      dictamenes: 'getDictamenPersonal',
    }),

    ...mapGetters('referencias', {
      referencias: 'getReferencias',
    }),

    ...mapGetters('permutacion', {
      permutaciones: 'getPermutaciones',
    }),

    ...mapGetters('faltasAdministrativas', {
      faltasAdministrativas: 'getFaltasAdministrativas',
    }),

    ...mapGetters('familiares', {
      familiares: 'getFamiliares',
    }),

    ...mapGetters('evaluacionesPersonal', {
      evaluaciones: 'getEvaluacionesPersonal',
    }),

    ...mapGetters('convocatorias', {
      convocatoriasNotificaciones: 'getConvocatoriasPersonal',
    }),

    ...mapGetters('condecoracionPersonal', {
      condecoraciones: 'getCondecoracionPersonal',
    }),

    menu: function () {
      return []
    },

    estudiosPersonal: function () {
      if (this.estudios) {
        return this.estudios.filter((estudio) => {
          return estudio.fk_idPersonal == this.id
        })
      } else return []
    },

    cursosPersonal: function () {
      if (this.cursos) {
        return this.cursos.filter((cursoAsignado) => {
          return cursoAsignado.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalProductividad: function () {
      if (this.evaluacionesProductividad) {
        return this.evaluacionesProductividad.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalRespetoPrincipios: function () {
      if (this.evaluacionesRespetoPrincipios) {
        return this.evaluacionesRespetoPrincipios.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('convocatorias', ['fetchConvocatoriasPersonalByPersonalId']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('documento', ['fetchDocumentoByPersonal']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),
    ...mapActions('evaluacionMedica', ['fetchEvaluacionMedicaByPersonal']),
    ...mapActions('dictamenPersonal', ['fetchDictamenPersonal']),
    ...mapActions('estatusDocumento', ['updateEstatusDocumento']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosPersonal']),
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignadosByPersonal']),
    ...mapActions('productividad', ['fetchProductividad']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('referencias', ['fetchReferenciasByPersonal']),
    ...mapActions('faltasAdministrativas', ['fetchFaltasAdministrativasByPersonal']),
    ...mapActions('familiares', ['fetchFamiliaresByPersonal']),
    ...mapActions('permutacion', ['fetchPermutacionesByPersonal']),
    ...mapActions('evaluacionesPersonal', ['fetchEvaluacionesById']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipiosById']),
    ...mapActions('productividad', ['fetchProductividadById']),
    ...mapActions('reactivoPrincipio', ['fetchReactivoPrincipio']),
    ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
    ...mapActions('indicadorEvaluacion', ['fetchIndicadorEvaluacion']),
    ...mapActions('actoRelevante', ['fetchActosRelevantes']),
    ...mapActions('tipoEvaluacion', ['fetchTipoEvaluacion']),
    ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
    ...mapActions('evaluacionAnual', ['fetchEvaluacionAnualById']),
    ...mapActions('habilidades', ['fetchHabilidades']),
    ...mapActions('principiosConstitucionales', ['fetchPrincipiosConstitucionales']),
    ...mapActions('valoresCapacidades', ['fetchValoresCapacidades']),
    ...mapActions('descripcionCriterio', ['fetchDescripcionCriterio']),
    ...mapActions('resultado', ['fetchResultados']),
    ...mapActions('estatusEvaluacion', ['fetchEstatusEvaluacion']),
    ...mapActions('reactivoValor', ['fetchReactivoValor']),
    ...mapActions('reactivosEvaluacion', [
      'fetchReactivosDesempenioInstitucional',
      'fetchReactivosRendimientoProfesionalismo',
    ]),
    ...mapActions('respetoPrincipiosValores', ['saveRespetoPrincipiosValores', 'fetchRespetoPrincipiosValores']),
    ...mapActions('rendimientoProfesionalismo', ['saveRendimientoProfesionalismo', 'fetchRendimientoProfesionalismo']),
    ...mapActions('desempeñoInstitucional', ['saveDesempeñoInstitucional', 'fetchDesempeñoInstitucional']),
    ...mapActions('condecoracionPersonal', ['fetchCondecoracionPersonal']),
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),

    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
    ...mapActions('sexo', ['fetchSexo']),

    async cargarDatosIniciales() {
      this.loadingPersonalData = true
      try {
        await Promise.all([
          this.fetchPersonalById(this.id),
          this.fetchEstudiosByPersonal(this.id),
          this.fetchDocumentoByPersonal(this.id),
          this.fetchReferenciasByPersonal(this.id),
          this.fetchFaltasAdministrativasByPersonal(this.id),
          this.fetchFamiliaresByPersonal(this.id),
          this.fetchPermutacionesByPersonal(this.id),
          this.fetchEvaluacionesById(this.id),
          this.fetchCondecoracionPersonal(this.id),
          this.fetchConvocatoriasPersonalByPersonalId(this.id),

          this.fetchMunicipios(),
          this.fetchEstadoCivil(),
          this.fetchTipoNacionalidad(),
          this.fetchSexo(),
          this.fetchGrupoSanguineo(),
        ])

        await Promise.all([
          this.fetchReactivoPrincipio(),
          this.fetchFrecuenciaRespetoPrincipio(),
          this.fetchFrecuenciaProductividad(),
          this.fetchTipoEvaluacion(),
          this.fetchHabilidades(),
          this.fetchPrincipiosConstitucionales(),
          this.fetchValoresCapacidades(),
          this.fetchResultados(),
          this.fetchEstatusEvaluacion(),
          this.fetchReactivoValor(),
          this.fetchReactivosRendimientoProfesionalismo(),
          this.fetchReactivosDesempenioInstitucional(),
        ])
      } catch (error) {
        console.error('Error al cargar datos del personal:', error)
      } finally {
        this.loadingPersonalData = false
      }
    },

    async recargarDatos() {
      await this.cargarDatosIniciales()
    },

    selectMenu: function (menu) {
      this.selectedMenu = menu
    },

    triggerUpdateEstatusDocumento: async function (documento) {
      await this.updateEstatusDocumento({
        idPersonal: documento.fk_idPersonal,
        idDocumentoPersonal: documento.iddocumentosPersonal,
      })
      await this.fetchDocumentoByPersonal(this.id)
    },

    download: function (url) {
      window.open(url, '_blank')
    },

    downloadQr: function (cuip) {
      window.open('http://ssctlaxcala.eonproduccion.net/qr/?cuip=' + cuip, '_blank')
    },

    generatePdf() {
      this.$refs.cv.generateReport()
    },

    triggerUpdatePersonal: async function () {
      var x = this.personal

      if (this.municipioNace) {
        this.personal.fk_idMunicipioNacimiento = this.municipioNace
      }
      if (this.municipioRadica) {
        this.personal.fk_idMunicipioRadica = this.municipioRadica
      }
      if (this.municipioDireccion) {
        this.personal.Contacto.Direccion.fk_idMunicipio = this.municipioDireccion
      }
      await this.updatePersonal(x)
    },

    save(date) {
      this.$refs.menu.save(date)
      this.personal.fechaNacimiento = moment(date).format(this.API_DATE_FORMAT)
    },

    triggerLogout: function () {
      this.logout()
      window.location.reload()
    },

    handleNavigateToEvaluation(tipo) {
      console.log('Navegando a evaluación:', tipo)
    },

    ensureIsAllowedUser() {
      const idPersonalLogueado = localStorage.getItem('idPersonal')

      if (idPersonalLogueado && Number(idPersonalLogueado) !== this.id) {
        const perfilUsuario = localStorage.getItem('perfil')

        if (perfilUsuario) {
          this.$router.push('/')
        }
      }
    },
  },
}
</script>
